/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Example_Box_LabelInputs */



/**
* | output |
* | --- |
* | "Example" |
*
* @param {Example_Box_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const example_box_label = /** @type {((inputs?: Example_Box_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Example_Box_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exemple")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ejemplo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Exemplo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esempio")
	return /** @type {LocalizedString} */ ("Example")
});